// German date/time input: what members type ↔ the ISO values the form works with.
// Independent of the browser language (native date/time pickers follow it: English, Sunday first, AM/PM).

const pad = (n: number) => String(n).padStart(2, '0');

/** "2027-03-10" → "10.03.2027" ('' for empty/invalid). */
export function formatDeDate(iso: string): string {
  const r = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  return r ? `${r[3]}.${r[2]}.${r[1]}` : '';
}

/**
 * Typed date → "yyyy-mm-dd", or null if it is not a real date.
 * Accepts 10.03.2027, 10.3.2027, 10.3.27, 10,3,27 (iPhone number pad), 10/3/2027, 10032027, 100327 and ISO 2027-03-10.
 */
export function parseDeDate(text: string): string | null {
  const t = text.trim();
  let d: number, m: number, y: number;
  let r = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec(t);
  if (r) [y, m, d] = [Number(r[1]), Number(r[2]), Number(r[3])];
  else if ((r = /^(\d{1,2})[.,/\- ](\d{1,2})[.,/\- ](\d{2}|\d{4})$/.exec(t))) {
    [d, m, y] = [Number(r[1]), Number(r[2]), Number(r[3])];
    if (r[3].length === 2) y += 2000;
  } else if ((r = /^(\d{2})(\d{2})(\d{4}|\d{2})$/.exec(t))) {
    [d, m, y] = [Number(r[1]), Number(r[2]), Number(r[3])];
    if (r[3].length === 2) y += 2000;
  } else return null;
  if (y < 1990 || y > 2100) return null;
  const date = new Date(y, m - 1, d);
  if (date.getFullYear() !== y || date.getMonth() !== m - 1 || date.getDate() !== d) return null; // 31.02.
  return `${y}-${pad(m)}-${pad(d)}`;
}

/** Typed time → "HH:MM" (24 h), or null. Accepts 19:30, 19.30, 19,30 (iPhone number pad), 1930, 930, 9, 9:5 → 09:05. */
export function parseTime(text: string): string | null {
  const t = text.trim();
  let h: number, min: number;
  let r = /^(\d{1,2})[:.,h ](\d{1,2})$/.exec(t);
  if (r) [h, min] = [Number(r[1]), Number(r[2])];
  else if ((r = /^(\d{1,2})$/.exec(t))) [h, min] = [Number(r[1]), 0];
  else if ((r = /^(\d{1,2})(\d{2})$/.exec(t))) [h, min] = [Number(r[1]), Number(r[2])];
  else return null;
  if (h > 23 || min > 59) return null;
  return `${pad(h)}:${pad(min)}`;
}
